import React from "react";
import { useParams, NavLink } from "react-router-dom";
import { useTranslation } from "react-i18next";

const TermsAndConditionsViewer: React.FC = () => {
  const { fileName } = useParams<{ fileName: string }>();
  const { t } = useTranslation("DocumentsTable");
  const backLink = "/documents"; // Change this if you want a different back link

  if (!fileName) {
    return <div className="p-4 text-red-500">No file specified.</div>;
  }

  return (
    <div className="md:mx-16 pb-[80px] mt-20 mb-16">
      <h2 className="text-primary-600 dark:text-white lg:text-[1.875rem] font-semibold mb-16">
        Wijziging contractformule
      </h2>
      <p className="text-primary-400 text-sm font-semibold">{fileName}</p>
      <div className="mt-8 mb-8">
        <NavLink
          to={backLink}
          className="px-[1.25rem] py-[0.53rem] bg-primary-600 dark:bg-primary-600 text-sm text-white rounded-3xl hover:bg-primary-700 dark:hover:bg-primary-700 font-semibold "
        >
          {t("goBack")}
        </NavLink>
      </div>
      <iframe
        src={`/${fileName}`}
        width="100%"
        height="700px"
        title={t("termsAndConditions") || "Terms and Conditions"}
        className="border-0"
      />
    </div>
  );
};

export default TermsAndConditionsViewer;
